import { Component, Input, OnInit } from '@angular/core';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';

@Component({
  selector: 'app-cart-component',
  templateUrl: './cart-component.component.html',
  styleUrls: ['./cart-component.component.scss'],
})
export class CartComponentComponent implements OnInit {
  @Input() cart: any;

  constructor(private tansactionService: TansactionService) {}

  ngOnInit(): void {
  }
}
